export interface DropdownStateEntry {
  isOpen: boolean;
  selectedItems?: string[];
}

export interface DoBoxDropdownState {
  dropdownStates: Record<string, DropdownStateEntry | boolean>; // Support both new and legacy format for backward compatibility
  isFromDoBoxPreview: boolean;
}

export interface DoBoxDropdownActions {
  saveDropdownStates: (dropdownStates: Record<string, boolean>) => void;
  saveDropdownStatesEnhanced: (
    dropdownStates: Record<string, DropdownStateEntry>,
  ) => void;
  restoreDropdownStates: () => Record<string, boolean>;
  restoreDropdownStatesEnhanced: () => Record<string, DropdownStateEntry>;
  saveDropdownSelectedItems: (entryId: string, selectedItems: string[]) => void;
  getDropdownSelectedItems: (entryId: string) => string[];
  resetDropdownStates: () => void;
  setFromDoBoxPreview: (isFromDoBoxPreview: boolean) => void;
  getIsFromDoBoxPreview: () => boolean;
  resetState: () => void;
}

export const INITIAL_DOBOX_DROPDOWN_STATE: DoBoxDropdownState = {
  dropdownStates: {},
  isFromDoBoxPreview: false,
};

export type DoBoxDropdownStore = DoBoxDropdownState & DoBoxDropdownActions;
